import { INTEGRATIONS_EVENTS } from '../../constants/events';
import {
  getDefaultState, isFormSubmitted, setFormSubmitted,
  INTEGRATIONS_FORMS_DETAILS, updateIntegrationFormFields
} from '../../utils/Integrations/utils';


// set default state
const defaultIntegrationFormState = getDefaultState();

const IntegrationsFormReducer = (state = defaultIntegrationFormState, actions) => {
  switch (actions.type) {
    case INTEGRATIONS_EVENTS.FORM_CHANGE : {
      state = Object.assign({},state, actions.payload);
      break;
    }
    case INTEGRATIONS_EVENTS.FORM_FIELD_CHANGE : {
      state.form = Object.assign({},state.form, actions.payload);
      break;
    }
    case INTEGRATIONS_EVENTS.FORM_OPEN : {
        if (state.type && state.forms[state.type]) {
            state.forms[state.type].status = 1;
        }
        break;
    }
    case INTEGRATIONS_EVENTS.FORM_CLOSE : {
        if (state.type && state.forms[state.type]) {
            state.forms[state.type].status = 0;
        }
        break;
    }
    case INTEGRATIONS_EVENTS.FORM_SUBMITTED : {
        if (state.type && state.forms[state.type]) {
            state.forms[state.type].status = 2;
        }
        break;
    }
    case INTEGRATIONS_EVENTS.INTEGRATION_SOURCE_CLEAR : {
        let source = actions.payload.source;
        if (state.sourcesSet && source)
            state.sourcesSet[source] = false;
        break;
    }
    case INTEGRATIONS_EVENTS.SET_FORM_TYPE : {
      // let jobStore = JobStore.getState();
      let jobStore = actions.payload.globalState;

      if (actions.payload.type) {
          state.type = actions.payload.type;
      }

      if (actions.payload.source) {
          let source = actions.payload.source;
        state.sourcesSet = Object.assign({}, state.sourcesSet);
        state.sourcesSet[source] = true;
    }

      if (jobStore.context.city)
          state.form.city.value = jobStore.context.city;

      if (jobStore.user.loggedIn) {
        if (jobStore.user.name)
          state.form.name.value = jobStore.user.name;

        if (jobStore.user.email)
          state.form.email.value = jobStore.user.email;

        if (jobStore.user.mobile)
          state.form.mobile.value = jobStore.user.mobile;
      }

      break;
    }
    case INTEGRATIONS_EVENTS.CLEAR_FORM : {
      if (state.type && state.forms[state.type]) {
        state.forms[state.type].status = 3;
        setFormSubmitted(state.type);
        state.type = '';
      }
      break;
    }
    case INTEGRATIONS_EVENTS.UPDATE_FORM_STATE: {
      const context = actions.payload.context || {};
      Object.keys(context).filter((key) => {
        if (context[key]['alwaysOn']) {
          state.forms[key] = {
            status: isFormSubmitted(key) ? 3 : 0
          };
          updateIntegrationFormFields(key, context[key]);
          return key;
        }
      });
      state.formDetails = Object.assign({}, INTEGRATIONS_FORMS_DETAILS);
      break;
    }
    default: break;
  }

  state = Object.assign({}, state);
  return state;
};

export default IntegrationsFormReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/IntegrationsReducer/index.js